// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"4642":"8875ff83dccb1e700a43","6592":"b1976609261de04934c9"}[chunkId] + ".css";
};